module.exports = __webpack_public_path__ + "img/Icon awesome-check-circle.021a0aac.svg";